"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Loader: {
      height: 20,
      width: 20,
      border: "3px solid ".concat(theme['$loader-border']),
      borderRadius: '100%',
      animationName: '$pulse',
      animationDuration: '1s',
      animationDelay: 0,
      animationIterationCount: 'infinite',
      animationFillMode: 'none',
      animationPlayState: 'running'
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(0.1)',
        opacity: 0.9
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map